import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { map, take } from 'rxjs';

export const SuperAdminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userService = inject(UserService);

  return userService.user$.pipe(
    take(1),
    map((user) => {
      if (user?.isSuperAdmin) {
        return true;
      }
      return router.parseUrl('/reservations');
    }),
  );
};
